export const PeopleFeedbackLoader = () => <div className="people-feedback__loader" />;
